import { addComponentEventHandlers } from "../../../assets/javascripts/lib/component_event_handler";

// app/assets/javascripts/application.js のメンテナンスを簡略化するため、ダミーを置いておく
addComponentEventHandlers("", () => {});
